module.exports = __webpack_public_path__ + "static/media/saude.671d787a.png";